<template>
  <div>
  </div>
</template>

<script>
import {fetchToken} from '../../services/authentication.js';

export default {
  methods: {
    async fetchTokenWrapper(code) {
      await fetchToken(code, this.$router);
    }
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      this.fetchTokenWrapper(code);
    }
  }
}
</script>